export const operationTypes = [
    "Transferencia mismo banco Perú",
    "Transferencia Interbancaria Perú",
    "Transferencia Internacional Perú",
    "Wire Local USA",
    "Wire International USA",
  ];
  